/**
 * Partial-payload notice (2026-09-14): a catalog endpoint whose compile budget ran out on a cold cache
 * returns `incomplete` (ft_catalog_budget_compile, ft_catalog_api_inc.php). Say so above the results —
 * never cut rows silently. Returns the node (caller inserts it) or null when the payload is complete.
 */
export function buildIncompleteNotice(incomplete: { unchecked: number; candidates: number } | undefined): HTMLElement | null {
    if (!incomplete || !(incomplete.unchecked > 0)) return null;
    const note = document.createElement('div');
    note.className = 'text-center text-warning small py-2';
    note.setAttribute('data-ft-catalog-incomplete', String(incomplete.unchecked));
    // Worded for rows AND aggregates: a tally endpoint (circles/spheres of magic) lists every row but its
    // counts miss the unprepared entries.
    note.textContent = `${incomplete.unchecked} of ${incomplete.candidates} entries are still being `
        + 'prepared, so this list may be incomplete — reload the page in a minute.';
    return note;
}

export function catalogIcon(id: string, w = 20, h = 20, title: string | boolean = false): string {
    return typeof iconMap === 'function' ? iconMap(id, w, h, title) : '';
}

export function appendTableCell(row: HTMLTableRowElement, className = ''): HTMLTableCellElement {
    const cell = document.createElement('td');
    if (className) cell.className = className;
    row.appendChild(cell);
    return cell;
}

export function appendIconAction(
    parent: HTMLElement,
    className: string,
    iconId: string,
    label: string,
    fn: () => void | Promise<void>,
): HTMLButtonElement {
    const button = document.createElement('button');
    button.type = 'button';
    button.className = className;
    button.setAttribute('aria-label', label);
    button.innerHTML = catalogIcon(iconId, 20, 20, label);
    button.addEventListener('click', () => { void fn(); });
    parent.appendChild(button);
    return button;
}

export function appendIconLink(parent: HTMLElement, href: string, className: string, iconId: string, label: string): HTMLAnchorElement {
    const link = document.createElement('a');
    link.href = href;
    link.className = className;
    link.setAttribute('aria-label', label);
    link.innerHTML = catalogIcon(iconId, 20, 20, label);
    parent.appendChild(link);
    return link;
}
